import {
	defaultEqmInspectResultDetailDto,
	defaultEqmInspectResultHeaderDto,
	EqmInspectResultDetailDto,
	EqmInspectResultHeaderDto,
} from "src/dtos/eqmInspectResult/eqmInspectResultDto";

export interface EQM2080_R01HeaderDto extends EqmInspectResultHeaderDto {

}

export const defaultEQM2080_R01HeaderDto: EQM2080_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	compCd: '',
	compNm: '',
	equipmentCd: '',
	equipmentNm: '',
	inspectDt: undefined,
	inspectCycle: '',
	inspectCycleNm: '',
	judgeResult: '',
	judgeResultNm: '',
	judgeEmpno: '',
	judgeEmpNm: '',
	approvorEmpno: '',
	approvorEmpNm: '',
	remark: '',

	inserted: false,
	isModified: false,
};

/** 점검기준 마스터 (inspect API 응답 / pivot 행 bootstrap용) */
export interface EQM2080_R01InspectMasterDto {
	eqmType: string;
	eqmTypeNm?: string;
	inspectCd: string;
	/** 점검방법 */
	inspectMethod?: string;
	/** 점검항목명 */
	inspectNm: string;
	/** 공정명 (inspect API remark) */
	remark?: string;
	/** 기준치 (inspect API standardValue) */
	standardValue?: string;
}

export interface EQM2080_R01DetailDto extends EqmInspectResultDetailDto {
	eqmType?: string;
	eqmTypeNm?: string;
}

export const defaultEQM2080_R01DetailDto: EQM2080_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	itemNo: '',
	compCd: '',
	equipmentCd: '',
	inspectCd: '',
	inspectCycle: '',
	inspectDt: undefined,
	inspectMethod: '',
	standardValue: '',
	inspectValue: '',
	inspectValue2: '',
	judgeResult: '',
	judgeResultNm: '',
	judgeEmpno: '',
	judgeEmpNm: '',
	actionResult: '',
	remark: '',

	inspectNm: '',
	inspectType: '',
	inspectTypeNm: '',
	valueType: '',
	valueTypeNm: '',

	eqmType: '',
	eqmTypeNm: '',

	inserted: false,
	isModified: false,
};

export type EQM2080_R01DayCellValue = string;

export interface EQM2080_R01DetailPivotDto {
	valueIndex: number;
	eqmType: string;
	eqmTypeNm?: string;
	inspectCd: string;
	/** 공정명 (DetailDto.remark 매핑) */
	inspectNm: string;
	/** 점검항목명 (마스터 inspectNm 매핑) */
	inspectItemNm: string;
	/** 점검방법 */
	inspectMethod: string;
	/** 기준치 (inspect API standardValue) */
	standardValue: string;
	dayValues: Record<string, EQM2080_R01DayCellValue>;
	/** 2차 점검값 (DetailDto.inspectValue2 매핑) */
	dayValues2: Record<string, EQM2080_R01DayCellValue>;
	dayMeta: Record<string, { itemNo?: string }>;
	isModified?: boolean;
	inserted?: boolean;
}

export const defaultEQM2080_R01DetailPivotDto: EQM2080_R01DetailPivotDto = {
	valueIndex: 0,
	eqmType: "",
	eqmTypeNm: "",
	inspectCd: "",
	inspectNm: "",
	inspectItemNm: "",
	inspectMethod: "",
	standardValue: "",
	dayValues: {},
	dayValues2: {},
	dayMeta: {},
	isModified: false,
};
